(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner-dior"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-hero]').forEach(function(hero) {
      var slides = hero.querySelectorAll('[data-hero-slide]');
      var dots = hero.querySelectorAll('[data-hero-dot]');
      var prevBtn = hero.querySelector('[data-hero-prev]');
      var nextBtn = hero.querySelector('[data-hero-next]');
      var autoplay = hero.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
      var current = 0;
      var timer = null;
      if (slides.length <= 1) return;
      function goTo(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); s.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); d.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
        current = index;
      }
      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }
      function start() { if (!autoplay) return; stop(); timer = setInterval(next, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      dots.forEach(function(dot) { dot.addEventListener('click', function() { goTo(parseInt(dot.getAttribute('data-index'), 10)); start(); }); });
      if (prevBtn) prevBtn.addEventListener('click', function() { prev(); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { next(); start(); });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      var startX = null;
      hero.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
      hero.addEventListener('touchend', function(e) { if (startX === null) return; var diff = e.changedTouches[0].clientX - startX; if (Math.abs(diff) > 40) { diff < 0 ? next() : prev(); } startX = null; start(); }, { passive: true });
      if ('IntersectionObserver' in window) { new IntersectionObserver(function(entries) { entries.forEach(function(e) { e.isIntersecting ? start() : stop(); }); }, { threshold: 0.1 }).observe(hero); }
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
